import { openIntercomMessenger } from '../../libs/intercom';
import { MessengerIcon } from '../Icons/MessengerIcon';
import { StyledLauncher } from './IntercomLauncher.styles';

export function IntercomLauncher() {
  return (
    <StyledLauncher
      aria-label="Open support chat"
      onClick={openIntercomMessenger}
      type="button"
    >
      <MessengerIcon />
    </StyledLauncher>
  );
}
